import { render, staticRenderFns } from "./anchor-container-item.vue?vue&type=template&id=35208f90&scoped=true&"
import script from "./anchor-container-item.vue?vue&type=script&lang=js&"
export * from "./anchor-container-item.vue?vue&type=script&lang=js&"
import style0 from "./anchor-container-item.vue?vue&type=style&index=0&id=35208f90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35208f90",
  null
  
)

export default component.exports